
enum ExVideoEvents {
    // 辞書情報の検索・更新
    LoadAllContextPhraseStarted = "[ExVideoEvent] LoadAllContextPhraseStarted",
    LoadAllContextPhraseComplete = "[ExVideoEvent] LoadAllContextPhraseComplete",
    UpdateContextPhraseStarted = "[ExVideoEvent] UpdateContextPhraseStarted",
    UpdateContextPhraseComplete = "[ExVideoEvent] UpdateContextPhraseComplete",
    UpdateContextPhraseFailed = "[ExVideoEvent] UpdateContextPhraseFailed",
    EditVideoCaptionStarted = "[ExVideoEvent] EditVideoCaptionStarted",
    EditVideoCaptionComplete = "[ExVideoEvent] EditVideoCaptionComplete",
    EditVideoCaptionFailed = "[ExVideoEvent] EditVideoCaptionFailed",

    // STT再実行
    RerunSTTStarted = "[ExVideoEvent] RerunSTTStarted",
    RerunSTTComplete = "[ExVideoEvent] RerunSTTComplete",
    RerunSTTFailed = "[ExVideoEvent] RerunSTTFailed",

    // STT公開ステータス更新
    UpdateCaptionPublicStateStarted = "[ExVideoEvent] UpdateCaptionPublicStateStarted",
    UpdateCaptionPublicStateComplete = "[ExVideoEvent] UpdateCaptionPublicStateComplete",
    UpdateCaptionPublicStateFailed = "[ExVideoEvent] UpdateCaptionPublicStateFailed", 

    // ビデオ処理状況確認
    LoadProcessStatusStarted = "[ExVideoEvent] LoadProcessStatusStarted",
    LoadProcessStatusComplete = "[ExVideoEvent] LoadProcessStatusComplete",
    LoadProcessStatusRepeatStarted = "[ExVideoEvent] LoadProcessStatusRepeatStarted",
    LoadProcessStatusRepeatComplete = "[ExVideoEvent] LoadProcessStatusRepeatComplete",

    // ビデオ再生オプション取得
    GetVideoOptionStarted = "[ExVideoEvent] GetVideoOptionStarted",
    GetVideoOptionComplete = "[ExVideoEvent] GetVideoOptionComplete",
    // ビデオ再生オプション更新
    UpdateVideoOptionStarted = "[ExVideoEvent] UpdateVideoOptionStarted",
    UpdateVideoOptionComplete = "[ExVideoEvent] UpdateVideoOptionComplete"

}

export default ExVideoEvents;
